module.exports = __webpack_public_path__ + "img/clock.4702e54a.svg";